import React,{useState} from 'react'
import './Login.css';
import {Link,useHistory} from "react-router-dom";
import {auth} from "./firebase";


function Login() {
    const [email, setEmail]=useState('');
    const [password, setPassword]=useState('');
    const history = useHistory();

    const signIn=e=>{
        e.preventDefault();
         auth
            .signInWithEmailAndPassword(email,password)
            .then(auth=>{
                    history.push('./')
        
            })
            .catch(error =>alert(error.message))



        // some firbase work
    }
     const register=e=>{
        e.preventDefault();
        auth
            .createUserWithEmailAndPassword(email,password)
            .then((auth)=>{
                if(auth){
                    history.push('./')
                }
        
            })
            .catch(error =>alert(error.message))



        // some firbase work
    }
    return (
        <div className="login">
            <Link to="/">
                <img className="login_logo" src="https://sguru.org/wp-content/uploads/2018/02/amazon_logo_RGB.jpg" alt=""/>

            </Link>
            <div className="login_container">
                <h1>Sign-In</h1>
                <form>
                    <h5>E-mail</h5>
                    <input type="text"value={email} onChange={e=>setEmail(e.target.value)}/>
                    <h5>Password</h5>
                    <input type="password" value={password} onChange={e=>setPassword(e.target.value)} />
                    <button type="submit" onClick={signIn} className="login_button">Sign In</button>
                </form>
                <p>By continuing, you agree to Amazon's Conditions of Use and Privacy Notice.</p>
                <button onClick={register} className="register_button">create your amazone account</button>
            </div>
            
        </div>
    )
}

export default Login
